import { useEffect, useState } from 'react';
import { Gavel } from 'lucide-react';

/**
 * SIL-643/SIL-647: auction close countdown. Ticks every minute — a
 * close-time is a coarse "closes in Nd Hh / Nh Mm" label, not a live seconds
 * clock. Shared by the marketplace browse card (SIL-643) and the listing
 * detail bid panel (SIL-647) — do not fork this.
 */
export function formatAuctionCountdown(closesAt: string): string {
  const ms = new Date(closesAt).getTime() - Date.now();
  if (ms <= 0) return 'Closed';
  const totalMinutes = Math.floor(ms / 60000);
  const days = Math.floor(totalMinutes / (60 * 24));
  const hours = Math.floor((totalMinutes % (60 * 24)) / 60);
  const minutes = totalMinutes % 60;
  if (days > 0) return `Closes in ${days}d ${hours}h`;
  if (hours > 0) return `Closes in ${hours}h ${minutes}m`;
  return `Closes in ${minutes}m`;
}

export function AuctionCountdown({ closesAt, className }: { closesAt: string; className?: string }) {
  const [label, setLabel] = useState(() => formatAuctionCountdown(closesAt));

  useEffect(() => {
    setLabel(formatAuctionCountdown(closesAt));
    const id = window.setInterval(() => setLabel(formatAuctionCountdown(closesAt)), 60_000);
    return () => window.clearInterval(id);
  }, [closesAt]);

  return (
    <span
      className={
        className ??
        'inline-flex items-center gap-1 rounded-full bg-amber-100 px-2 py-0.5 text-amber-800'
      }
    >
      <Gavel className="size-3" aria-hidden="true" />
      {label}
    </span>
  );
}
